import { render, staticRenderFns } from "./details.vue?vue&type=template&id=47b2eee2&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=47b2eee2&prod&scoped=true&lang=less&"
import style1 from "./details.vue?vue&type=style&index=1&id=47b2eee2&prod&lang=less&"
import style2 from "./details.vue?vue&type=style&index=2&id=47b2eee2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2eee2",
  null
  
)

export default component.exports